<template>
	<article class="small-12" v-highlight v-if="event">
        <pre class="flex">
			<code class="small-12 json">
{
    payment_method: {
        billing_details: {
            name: "{{event.attributes.request.payment_method.billing_details.name}}"
        },
        setup_future_usage: "{{event.attributes.request.setup_future_usage}}"
    }
}
			</code>
        </pre>
	</article>
</template>

<script>

	// Import the mixins
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'
	import { DatesFilters } from '@/mixins/filters/DatesFilters'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'InvoicePaymentEventRequest',

		/*
		**  Register the mixins
		*/

		mixins: [

			MoneyConversions,
			DatesFilters

		],

		/*
		**  Set the props
		*/

		props: {

			event: {
				type: Object,
				default: () => null
			}

		}

	}

</script>